// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockOutlinedSvg from "@ant-design/icons-svg/es/asn/UnlockOutlined";
import AntdIcon from '../components/AntdIcon';

var UnlockOutlined = function UnlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockOutlinedSvg
  }));
};

UnlockOutlined.displayName = 'UnlockOutlined';
export default /*#__PURE__*/React.forwardRef(UnlockOutlined);